












import { Component, Vue, Prop, Model, Watch } from 'vue-property-decorator'
import { MessageText } from '@/services/data'
import { ElForm } from 'element-ui/types/form'

@Component
export default class NumberRowSelector extends Vue {
  $refs: {
    textForm: ElForm;
  }

  mounted () {
    this.formValue.inputValue = this.value
  }

  formValue: { inputValue: any } = { inputValue: null }
  message: MessageText = null
  @Model('input') value: any
  // do not put default value to prop value
  @Prop() rules: any
  @Prop() items: Array<any> | number

  // @Emit('input')
  handleChange () {
    this.$emit('input', this.formValue.inputValue)
  }

  @Watch('value')
  onValueChanged (v: any) {
    this.formValue.inputValue = v
  }

  @Watch('formValue.inputValue')
  onInputValueChanged (v: any) {
    this.$emit('input', v)
  }

  // if use @Emit,do not use this.$emit again, @Emit will return the function value to parent
  submit () {
    this.$refs.textForm.validate((valid: boolean) => {
      if (valid) {
        this.$emit('change')
      }
    })
  }
}
